import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e3e367d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "el-dialog__body-title track-title" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1))
const _hoisted_6 = { class: "el-dialog__body-footer flex-ter-end" }

import { t } from '@/plugins/i18n'
import { ref } from 'vue'
import UploadPdf from '@/components/common/UploadFilePDF.vue'
import { uploadBoxMarkLink } from '@/apis/inShipping'
import { ElMessage } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  emits: ['submit'],
  setup(__props, { expose, emit }) {

const visible = ref(false)
const rowItem = ref({})
const finalFile = ref()
const open = (row: any) => {
  console.log(row)
  rowItem.value = row
  if (row.boxMarkLink) {
    const file: any = row.boxMarkLink.split(',')
    finalFile.value = file.map((v: any) => {
      return {
        name: v,
        raw: {
          url: v
        }
      }
    })
  }
  visible.value = true
}
const close = () => {
  visible.value = false
}
const changeFile = (file: any) => {
  finalFile.value = file
}
const submit = () => {
  if (finalFile.value.length === 0) {
    ElMessage.warning(t('请上传箱唛'))
    return
  }
  uploadBoxMarkLink({
    boxMarkLinkList: [finalFile.value.map((v: any) => {
      return v.raw.url
    }).join(',')],
    deliveryTaskCode: rowItem.value.deliveryTaskCode
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('上传成功'))
      visible.value = false
      emit('submit')
    }
  })
}
expose({
  open
})


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    "destroy-on-close": "",
    onClose: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(rowItem.value.boxMarkLink ? _unref(t)('修改箱唛') : _unref(t)('上传箱唛')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createTextVNode(_toDisplayString(_unref(t)('箱唛文件')) + ":", 1)
          ]),
          _createElementVNode("div", null, [
            _createVNode(UploadPdf, {
              onChange: changeFile,
              limit: 100,
              file: finalFile.value
            }, null, 8, ["file"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_button, { onClick: close }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('保存')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})